var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 6C28.8402 6 36 11.3797 36 18.0274C36 22.1428 33.2875 25.7945 28.9814 27.9935C28.9939 27.9935 29.0059 27.9985 29.0147 28.0073C29.0236 28.0161 29.0285 28.0281 29.0285 28.0406C29.0285 29.852 30.3359 31.7394 30.9479 32.7501C30.9938 32.8667 31.0254 32.9883 31.0421 33.1124C31.0309 33.353 30.9269 33.5798 30.752 33.7453C30.5771 33.9108 30.3449 34.0021 30.1041 34H29.8687C26.7361 33.5326 23.7881 30.6598 23.0892 29.8194C22.0676 29.9786 21.0333 30.0417 20 30.0077C11.1598 30.0077 4 24.6715 4 18.0274C4 11.3834 11.1598 6 20 6Z",
    fill: "#B0B3F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBubble);
export default __webpack_public_path__ + "static/media/text-bubble.a82798aa.svg";
export { ForwardRef as ReactComponent };